import React from "react";
import styles from "./workspace.module.css";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";

export const Workspace = () => {

  return (
    // data-tour: what the tutorial spotlights for "this page".
    <Box className={styles.workspace} data-tour="page">
      <Outlet />
    </Box>
  );
};
